import * as React from "react";
import { 
  TextInput,
  required,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import Transformer from "../../common/Transformer";
import { NewsletterEditComponent } from "./";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

const filterToQuery = (searchText) => ({
  "search": searchText,
});

export const NewsletterEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        user: data.user.id,
      },
    });

    return data;
  };

  return (
    <Edit
      component={NewsletterEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={6} sm={12}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item lg={6} sm={12}>
            <ReferenceInput
              source="user.id"
              reference="admin/users"
            >
              <AutocompleteInput
                filterToQuery={(e) => filterToQuery(e)}
                optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                size="small"
                label="User"
              />
            </ReferenceInput>
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="email" type="email" validate={required()}/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
